import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

interface SelectableChipOption {
  id: string;
  label: string;
}

@Component({
  selector: 'app-step-four',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './step-four.component.html',
  styleUrl: './step-four.component.scss',
})
export class StepFourComponent {
  @Input() objectiveOptions: SelectableChipOption[] = [];
  @Input() selectedObjectiveIds!: Set<string>;
  @Input() customObjectives: SelectableChipOption[] = [];
  @Input() customObjectiveInput = '';

  toggleObjectiveSelection(objectiveId: string): void {
    if (this.selectedObjectiveIds.has(objectiveId)) {
      this.selectedObjectiveIds.delete(objectiveId);
      return;
    }

    this.selectedObjectiveIds.add(objectiveId);
  }

  isObjectiveSelected(objectiveId: string): boolean {
    return this.selectedObjectiveIds.has(objectiveId);
  }

  updateCustomObjectiveInput(event: Event): void {
    this.customObjectiveInput = (event.target as HTMLInputElement).value;
  }

  addCustomObjective(): void {
    const label = this.customObjectiveInput.trim();

    if (!label) {
      return;
    }

    const existingCustomObjective = this.customObjectives.find(
      (objective) => objective.label.toLowerCase() === label.toLowerCase(),
    );

    if (existingCustomObjective) {
      this.selectedObjectiveIds.add(existingCustomObjective.id);
      this.customObjectiveInput = '';
      return;
    }

    const id = `step-four-custom-${label
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')}`;

    this.customObjectives.push({ id, label });
    this.selectedObjectiveIds.add(id);
    this.customObjectiveInput = '';
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.addCustomObjective();
    }
  }
}
